import { ValuePillarItem } from '../types/content';

export const valuePillars: ValuePillarItem[] = [
  {
    id: 'roi-first',
    label: 'ROI First',
    copy: 'Decisions tied to measurable business value and clear metric outcomes.',
    emphasis: 86,
    iconName: 'Target',
    details: [
      'Every feature scope is validated against business ROI',
      'Clear milestone tracking and transparent progress metrics',
      'Focus on revenue acceleration & cost efficiency',
    ],
  },
  {
    id: 'smart-costing',
    label: 'Smart Costing',
    copy: 'Practical scope, architecture, and technology choices tailored to budget.',
    emphasis: 72,
    iconName: 'ShieldCheck',
    details: [
      'No bloated software architectures or unnecessary licenses',
      'Flexible engagement models adapted to client growth stage',
      'Transparent pricing with zero hidden fees',
    ],
  },
  {
    id: 'long-term',
    label: 'Long-Term Maintainability',
    copy: 'Systems engineered with clean architecture that scale effortlessly as you grow.',
    emphasis: 80,
    iconName: 'Cpu',
    details: [
      'Strict TypeScript interfaces & clean modular code',
      'Comprehensive documentation & automated test coverage',
      'Future-proof technology stack selections',
    ],
  },
  {
    id: 'innovation',
    label: 'Practical Innovation',
    copy: 'Applied cutting-edge AI, cloud, and automation tailored to real operational needs.',
    emphasis: 84,
    iconName: 'Zap',
    details: [
      'Applied machine learning & intelligent process automation',
      'Cloud-native modern web & mobile technology',
      'Continuous performance tuning & optimization',
    ],
  },
];
